import React, { ChangeEvent, useState } from "react";
import RegisterHere from "../Components/Auths/RegisterHere";
import { RegisterCompany } from "../types";
import { useAppDispatch } from "../app/store";
import { toast } from "react-toastify";
import { addCompany } from "../features/authSlice";
import { useNavigate } from "react-router-dom";
import MainLayout from "../Components/Layouts/MainLayout";

const Register = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  //formdata
  const [formData, setFormData] = useState<RegisterCompany>({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirmPassword: "",
    company_name: "",
    address: "",
    phone: "",
    role: "",
  });
  //for spinner
  const [loading, setLoading] = useState(false);

  //handle onchange
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //handle submit
  const registerCompany = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Prevent form submission first
    setLoading(true);
    if (formData.password !== formData.confirmPassword) {
      setLoading(false);
      return toast.warning("Password does not match");
    }

    const data: RegisterCompany = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      password: formData.password,
      company_name: formData.company_name,
      confirmPassword: formData.confirmPassword,
      address: formData.address,
      phone: formData.phone,
      role: "super",
    };

    dispatch(addCompany(data))
      .unwrap() // Unwraps the payload or throws an error
      .then((response: string) => {
        setLoading(false);
        navigate("/login");
        toast.success("Please check your email to verify your account");
      })
      .catch((error: string) => {
        setLoading(false);
        toast.error(error);
      });
  };

  return (
    <MainLayout>
      <RegisterHere
        formData={formData}
        onChange={handleChange}
        registerCompany={registerCompany}
        loading={loading}
      />
    </MainLayout>
  );
};

export default Register;
